export const MEASUREMENT_DEFAULTS: Record<
  string,
  {
    metric: string;
    imperial: string;
    labelMetric: string;
    labelImperial: string;
  }
> = {
  height: {
    metric: "170",
    imperial: "5.9",
    labelMetric: "cm",
    labelImperial: "ft",
  },
  weight_current: {
    metric: "80",
    imperial: "175",
    labelMetric: "kg",
    labelImperial: "lb",
  },
  weight_goal: {
    metric: "80",
    imperial: "175",
    labelMetric: "kg",
    labelImperial: "lb",
  },
};
